import * as React from 'react';

import { Link } from 'libs/router';

import SystemMessageWrapperContext from '../wrapper/context/SystemMessageWrapperContext';

import { __t, applyTranslations } from 'utils/language';
import { FUNC_RETURN_NULL } from '../utils/system-message';

import './system-message-campaign-ended.scss';

applyTranslations(require('./system-message-campaign-ended.i18n.json'));

const MSG_KEY = 'system_message_campaign_ended';

const SystemMessageCampaignEnded = (): JSX.Element => {
  const context = React.useContext(SystemMessageWrapperContext);
  const {
    campaign,
    renderAvatar = FUNC_RETURN_NULL
  } = context;

  const renderLink = (): React.ReactNode => {
    const text = __t(`${MSG_KEY}.links.view_reporting`);

    return (
      <Link
        to={`/campaigns/ccm/${campaign?.id}/report`}
        target="_blank"
        className="system-message-campaign-ended__link"
        title={text}
      >
        {text}
      </Link>
    );
  };

  const renderPrimaryText = (): React.ReactNode => {
    const text = __t(`${MSG_KEY}.messages.campaign_ended`);

    return (
      <div
        className="system-message-campaign-ended__primary-text"
        title={text}
      >
        {text}
      </div>
    );
  };

  return (
    <React.Fragment>
      {renderAvatar('starburst-with-plus-inside-circle-custom-fg')}
      <div className="system-message-campaign-ended">
        {renderPrimaryText()}
        {renderLink()}
      </div>
    </React.Fragment>
  );
};

export default SystemMessageCampaignEnded;
